export default __webpack_public_path__ + "static/media/products.f075ab1a.svg";